import Button from "../../components/ui/Button";
import Modal from "../../components/ui/Modal";
import React, { useState } from "react";
import "./GeneratePriceModal.css";
import { CartItem, CartSubItem } from "../../data/mockPurchaseOrders";

interface GeneratePriceModalProps {
  item: CartItem;
  onClose: () => void;
  onSave: (cartItemId: string, updatedSubItems: CartSubItem[]) => void;
}

const GeneratePriceModal: React.FC<GeneratePriceModalProps> = ({
  item,
  onClose,
  onSave,
}) => {
  const [prices, setPrices] = useState<{ [key: string]: string }>({});

  const handlePriceChange = (itemName: string, value: string) => {
    if (/^\d*\.?\d*$/.test(value)) {
      setPrices((prev) => ({ ...prev, [itemName]: value }));
    }
  };

  const handleUpdatePrice = () => {
    const updatedSubItems = item.subItems.map((subItem) => ({
      ...subItem,
      price: parseFloat(prices[subItem.name] || "0"),
    }));
    onSave(item.id, updatedSubItems);
  };

  const isFormValid = item.subItems.every(
    (subItem) => prices[subItem.name] && parseFloat(prices[subItem.name]) >= 0,
  );

  return (
    <Modal title={<>Generate Price</>} onClose={onClose} size="medium">
<div className="modal-content legacy-modal-content" onClick={(e) => e.stopPropagation()}>

        <div className="modal-body">
          <div className="price-inputs-grid">
            {item.subItems.map((subItem) => (
              <div key={subItem.name} className="price-input-group">
                <label htmlFor={subItem.name}>{subItem.name}</label>
                <input
                  type="text"
                  id={subItem.name}
                  placeholder="Enter here"
                  value={prices[subItem.name] || ""}
                  onChange={(e) =>
                    handlePriceChange(subItem.name, e.target.value)
                  }
                  autoComplete="off"
                />
              </div>
            ))}
          </div>
        </div>
        <div className="modal-footer">
          <Button type="button"
            className="update-price-btn"
            onClick={handleUpdatePrice}
            disabled={!isFormValid}
            title={
              isFormValid
                ? "Save prices"
                : "Please enter a valid price for all items"
            }
          >
            Update Price
          </Button>
        </div>
      </div>
</Modal>
  );
};

export default GeneratePriceModal;
